
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("gSl96"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("gSl96", function(module, exports) {

let $c4921799de905373$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c4921799de905373$var$load("h3ABO"),
    $c4921799de905373$var$load("9hYRW"),
    $c4921799de905373$var$load("kpm7S"),
    $c4921799de905373$var$load("kc8tx"),
    $c4921799de905373$var$load("2YffH"),
    $c4921799de905373$var$load("g7ggm"),
    $c4921799de905373$var$load("eEyVs"),
    $c4921799de905373$var$load("6mHrv"),
    $c4921799de905373$var$load("awWN9"),
    $c4921799de905373$var$load("9CYct"),
    $c4921799de905373$var$load("fP9Su"),
    $c4921799de905373$var$load("3KcX6"),
    $c4921799de905373$var$load("hZtKG"),
    $c4921799de905373$var$load("dkqvW"),
    $c4921799de905373$var$load("lVO3w"),
    $c4921799de905373$var$load("hyzoX"),
    $c4921799de905373$var$load("h9Ed7"),
    $c4921799de905373$var$load("eBRUf"),
    $c4921799de905373$var$load("kbRvk"),
    $c4921799de905373$var$load("tKhaz"),
    $c4921799de905373$var$load("hwT9D"),
    $c4921799de905373$var$load("j4Bpe"),
    $c4921799de905373$var$load("cD6Zr"),
    $c4921799de905373$var$load("k3jER"),
    $c4921799de905373$var$load("9wzNh"),
    $c4921799de905373$var$load("8YSo7"),
    $c4921799de905373$var$load("9ldRJ"),
    $c4921799de905373$var$load("50ame"),
    $c4921799de905373$var$load("7do1E"),
    $c4921799de905373$var$load("77dkW"),
    $c4921799de905373$var$load("1MlIV"),
    $c4921799de905373$var$load("6iz6l"),
    $c4921799de905373$var$load("4SCW2"),
    $c4921799de905373$var$load("aXHNO"),
    $c4921799de905373$var$load("kmvek"),
    $c4921799de905373$var$load("Wowvf"),
    $c4921799de905373$var$load("421lv"),
    $c4921799de905373$var$load("dek7I"),
    $c4921799de905373$var$load("3SmkN"),
    $c4921799de905373$var$load("dYtBN"),
    $c4921799de905373$var$load("kNV5Y"),
    $c4921799de905373$var$load("6wr18"),
    $c4921799de905373$var$load("kjZZD"),
    $c4921799de905373$var$load("7cDV0"),
    $c4921799de905373$var$load("ijD5W"),
    $c4921799de905373$var$load("3JSgG"),
    $c4921799de905373$var$load("37ldp"),
    $c4921799de905373$var$load("ffEVr"),
    $c4921799de905373$var$load("9AXkC"),
    $c4921799de905373$var$load("28arV"),
    $c4921799de905373$var$load("hhss7"),
    $c4921799de905373$var$load("l1BQC"),
    $c4921799de905373$var$load("jlSF3"),
    $c4921799de905373$var$load("dP7ao"),
    $c4921799de905373$var$load("hogcU"),
    $c4921799de905373$var$load("4pqtR"),
    $c4921799de905373$var$load("5XqRg"),
    $c4921799de905373$var$load("7EorR"),
    $c4921799de905373$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.65e00dc8.js.map
